/* ══════════════════════════════════════════════════════════════════
   门店地图的运行时

   **服务端把八家店全部渲染出来，这里只做加减法**：显示/隐藏、压暗、
   排序、算距离。没有一次请求，所以筛选是即时的，而且没 JS 时
   整份清单和整张地图仍然在那儿（少的只是筛选和排序）。

   三条筛是彼此独立的：
     文本  —— 在自己的数据上匹配（店名 / 城市 / 国家 / 地址）。
              **不是地理编码**：那要 key、要钱、要一次外站请求，
              还会多出一条「找不到这个地址」的死路。
     国家  —— 下拉。
     车型  —— 下拉。`data-all` 的店永远命中。

   距离只在按下「用我的位置」之后才有：坐标来自浏览器自己的定位 API
   （没有第三方），球面距离在这儿算，清单按远近重排。
   **没定位就不显示公里数** —— 编一个数字出来是骗人。

   手机上点位不开弹卡，直接滚到那张卡：268 宽的弹卡在 390 的屏上
   要么被裁要么盖住半张图，而卡片本来就在下面一屏之内。

   ── 真地图（2026-08-07 起）──
   `[data-map]` 上有 `data-tiles` 时，这一节滚进视口才注入 Leaflet
   （两个文件都在 assets 里，不走 CDN），然后：

     Leaflet 只管 **瓦片、拖拽、缩放、投影**。
     点位仍然是服务端渲染的那批 DOM，只是 `--x/--y` 改由
     `latLngToContainerPoint` 每帧重算 —— 交给 L.marker 就得重写弹卡、
     重写筛选联动、重写清单↔点位那套 aria-current，而这三件已经有了。

   关掉了两件 Leaflet 默认行为，都是为了这一页：
     `scrollWheelZoom` —— 滚页面时地图不该把页面吃掉，点一下才接管滚轮。
     `zoomAnimation`  —— 瓦片在动画的 250ms 里飞，点位是每帧重摆的，
                          两者对不上会看见点位滑一下才归位。关掉就都是硬切，
                          反而是齐的。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PHONE = window.matchMedia('(max-width: 989px)');

  function init(root) {
    if (root.dataset.mapReady) return;
    root.dataset.mapReady = '1';

    var list = root.querySelector('[data-map-list]');
    var cards = [].slice.call(root.querySelectorAll('[data-shop]'));
    var pins = [].slice.call(root.querySelectorAll('[data-pin]'));
    var count = root.querySelector('[data-map-count]');
    var empty = root.querySelector('[data-map-empty]');
    var search = root.querySelector('[data-map-search]');
    var state = { q: '', cc: '', model: '', here: null };

    function models(el) { return (el.dataset.models || '').split(','); }

    function hasBike(el) {
      if (!state.model) return true;
      if (el.dataset.all === 'true') return true;
      return models(el).indexOf(state.model) > -1;
    }

    function inScope(el) {
      if (state.cc && el.dataset.cc !== state.cc) return false;
      if (state.q && (el.dataset.find || '').indexOf(state.q) < 0) return false;
      return true;
    }

    /* 球面距离（km）。坐标是元对象里的 lat/lng，定位是浏览器给的。 */
    function km(lat, lng) {
      var R = 6371, r = Math.PI / 180;
      var dLa = (lat - state.here.lat) * r;
      var dLo = (lng - state.here.lng) * r;
      var h = Math.sin(dLa / 2) * Math.sin(dLa / 2)
        + Math.cos(state.here.lat * r) * Math.cos(lat * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
      return Math.round(2 * R * Math.asin(Math.sqrt(h)));
    }

    function apply() {
      var shown = 0, matched = 0;

      cards.forEach(function (card) {
        var on = inScope(card);
        var bike = hasBike(card);
        card.hidden = !on;
        card.classList.toggle('is-off', on && !bike);
        if (on) { shown++; if (bike) matched++; }

        var dist = card.querySelector('[data-dist]');
        var kind = card.querySelector('[data-kind]');
        if (state.here && card.dataset.lat) {
          var d = km(parseFloat(card.dataset.lat), parseFloat(card.dataset.lng));
          card.dataset.km = d;
          if (dist) { dist.textContent = d + ' km'; dist.hidden = false; }
          if (kind) kind.hidden = true;
        } else if (dist) {
          dist.hidden = true;
          if (kind) kind.hidden = false;
        }

        /* 命中的那颗车型 chip 认得出来 —— 否则人还得自己在五颗里找 */
        [].forEach.call(card.querySelectorAll('[data-chip]'), function (chip) {
          chip.classList.toggle('is-hit',
            !!state.model && (card.dataset.all === 'true' || chip.dataset.chip === state.model));
        });
      });

      pins.forEach(function (pin) {
        var card = root.querySelector('[data-shop="' + pin.dataset.pin + '"]');
        if (!card) return;
        pin.hidden = card.hidden;
        pin.classList.toggle('is-off', card.classList.contains('is-off'));
      });

      /* 有距离就按远近重排。用 CSS order，不动 DOM —— 不动 DOM 就不会丢焦点。 */
      if (state.here) {
        cards.slice().sort(function (a, b) { return (+a.dataset.km) - (+b.dataset.km); })
          .forEach(function (card, i) { card.style.order = i; });
      } else {
        cards.forEach(function (card) { card.style.order = ''; });
      }

      /* **筛完就重新取景。** 挑了 X3000 之后还盯着一整张欧洲图，
         等于没筛 —— 地图要跟着答案收紧。示意图做不到这件事（它的
         投影是服务端一次算死的），真地图能，这是接它的一半理由。 */
      if (state.map) fit(root, state.map);

      if (empty) empty.hidden = shown > 0;
      if (list) list.classList.toggle('is-empty', shown === 0);
      if (count) {
        count.innerHTML = '<b>' + matched + '</b> ' + (count.dataset.of || '')
          .replace('[count]', cards.length)
          .replace('[nearest]', state.here ? (count.dataset.nearest || '') : '');
      }
    }

    function pick(id) {
      cards.forEach(function (c) { c.setAttribute('aria-current', c.dataset.shop === id ? 'true' : 'false'); });
      pins.forEach(function (p) { p.setAttribute('aria-current', p.dataset.pin === id ? 'true' : 'false'); });

      /* 从清单里选一家，地图要跟过去 —— 否则选中的那颗可能在视野外，
         「选了」这件事在图上就没有任何回音。**只平移不缩放**：
         突然拉到街道级会把「它周围还有哪几家」整个丢掉。 */
      var target = root.querySelector('[data-pin="' + id + '"]');
      if (state.map && target && target.dataset.lat && !target.hidden) {
        var at = [+target.dataset.lat, +target.dataset.lng];
        /* 原来这里只平移不缩放，理由是「别一下拉到街道级，把周围还有哪几家丢掉」——
           那条理由保留，但**停在国家级视野上同样没回答「在哪」**。
           折中：只有当前还看得很远时才补到 12（≈20 km across，不是街道级，
           邻近门店仍在视野里）；人自己已经拉近过就只平移，不把他拽回去。 */
        var want = Math.min(12, state.map.getMaxZoom());
        if (state.map.getZoom() < want) state.map.setView(at, want, { animate: true });
        else state.map.panTo(at, { animate: true });
      }

      /* 手机上那张卡贴在地图下沿，不挂在点位上 —— 见 CSS 里那段。 */
      sheet(root, PHONE.matches ? id : null);

      /* **翻边要在这时候重算。** 弹卡真正被人看到就是这一刻，而它的高度
         直到此刻才是最终值：里面那张门店照片是懒加载的，图没到之前
         整张卡矮一大截，按那个高度算出来的「上面装得下」是假的。 */
      requestAnimationFrame(function () { reflip(root); });
      /* 选中的店同时喂给同一页的预约表单 —— 两节之间只靠这一个事件说话 */
      var card = root.querySelector('[data-shop="' + id + '"]');
      if (card) {
        document.dispatchEvent(new CustomEvent('eb:store-picked', {
          detail: {
            handle: card.dataset.handle, name: card.dataset.name, city: card.dataset.city,
            address: card.dataset.address, hours: card.dataset.hours,
            phone: card.dataset.phone, kind: card.dataset.kind, open: card.dataset.open
          }
        }));
      }
    }

    root.addEventListener('click', function (e) {
      /* 卡片和弹卡都在 <button> 里，里面不能再嵌 <a> —— 所以外链是带
         `data-open` 的 span，由这里打开。`noopener` 是必须的。 */
      var out = e.target.closest('[data-open]');
      if (out) {
        e.stopPropagation();
        window.open(out.dataset.open, '_blank', 'noopener,noreferrer');
        return;
      }
      /* 「Book here」＝选中这家店 ＋ 滚到表单。选中由下面那段做，
         这里只负责把人送到表单那一节 —— 不然点完什么也没发生。 */
      var book = e.target.closest('[data-book]');
      if (book) {
        var card = book.closest('[data-shop]') || book.closest('[data-pin]');
        if (card) {
          pick(card.dataset.shop != null ? card.dataset.shop : card.dataset.pin);
        }
        var form = document.querySelector('[data-test-ride]');
        if (form) form.scrollIntoView({ block: 'start', behavior: 'smooth' });
        return;
      }
      var row = e.target.closest('[data-map-model]');
      if (row) {
        state.model = row.dataset.mapModel;
        setTrigger(row, root.querySelector('[data-trig-model]'));
        apply();
        return;
      }
      var cty = e.target.closest('[data-map-country]');
      if (cty) {
        state.cc = cty.dataset.mapCountry;
        setTrigger(cty, root.querySelector('[data-trig-country]'));
        apply();
        return;
      }
      if (e.target.closest('[data-map-clear]')) {
        state.q = ''; state.cc = ''; state.model = '';
        if (search) search.value = '';
        resetTriggers(root);
        apply();
        return;
      }
      if (e.target.closest('[data-map-geo]')) { locate(root, state, apply); return; }

      var card = e.target.closest('[data-shop]');
      if (card && !e.target.closest('a')) { pick(card.dataset.shop); return; }

      var pin = e.target.closest('[data-pin]');
      if (pin) {
        if (e.target.closest('.eb-map__pop')) return;
        /* ⚠️ 手机上这里原来是「滚到下面那张清单卡」。已删（2026-08-07）——
           点一颗点位却把整页滚走，人会以为自己点错了，刚拖到的那块地图
           也跟着离开视野。现在卡就贴在地图下沿，一个手势一个结果。 */
        pick(pin.dataset.pin);
      }
    });

    if (search) {
      search.addEventListener('input', function () {
        state.q = search.value.trim().toLowerCase();
        apply();
      });
    }

    /* 首行那颗「找离我最近的」。**它不碰这一节的 DOM，只发一个事件** ——
       和 `eb:store-picked` 是同一条契约，方向相反。滚过来的事首行自己做了，
       这里只负责真正去定位。 */
    document.addEventListener('eb:store-locate', function () {
      locate(root, state, apply);
    });

    apply();

    /* 示意图形态下点位是服务端摆的，但**翻边仍然要量过才算数** ——
       服务端那套阈值是按弹卡「大概 268×200」写死的，有照片时它高得多。 */
    reflip(root);
    window.addEventListener('resize', function () { reflip(root); });
    /* 弹卡里的照片是懒加载的：它一到，卡就变高，翻边的答案可能就变了。
       用捕获阶段听 —— `load` 不冒泡。 */
    root.addEventListener('load', function (e) {
      if (e.target.closest && e.target.closest('.eb-map__pop')) reflip(root);
    }, true);

    /* 真地图。注入是异步的，所以 apply 先跑一遍，地图好了再补摆一次点位。 */
    tiles(root, function (m) {
      state.map = m;
      place(root, m);
      fit(root, m);
    });
  }

  /* 手机上那张贴着地图下沿的长条卡。
     **是挪不是复制** —— 一家店的弹卡永远只有一份 DOM，复制出来的那份
     迟早会和原件说两种话（内容改了一处没改另一处）。
     挪走之后它不再是点位的后代，所以 `[data-book]` 找不到 `[data-pin]` 了；
     宿主自己挂上 `data-shop`，点击分发那条路照旧走得通。 */
  function sheet(root, id) {
    var map = root.querySelector('[data-map]');
    if (!map) return;
    var host = map.querySelector('[data-map-sheet]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'eb-map__sheet';
      host.setAttribute('data-map-sheet', '');
      host.hidden = true;
      map.appendChild(host);
    }
    /* 先把上一张送回它自己的点位里，再接新的 */
    var open = host.firstElementChild;
    if (open) {
      var home = root.querySelector('[data-pin="' + host.dataset.shop + '"]');
      if (home) home.appendChild(open);
      else open.remove();
    }
    host.removeAttribute('data-shop');
    host.hidden = true;
    if (id == null) return;

    var pin = root.querySelector('[data-pin="' + id + '"]');
    var pop = pin && pin.querySelector('.eb-map__pop');
    if (!pop) return;
    host.appendChild(pop);
    host.dataset.shop = id;
    host.hidden = false;
  }

  /* 翻完边还要**量一次，把它推回框内**。
     翻边只回答「上面还是下面」，可有时候两边都装不下 —— 一张 389 高的
     弹卡、一张 520 高的图、点位又在正中间，翻到哪边都会被 `.eb-map` 的
     overflow 切掉一截（图一里被切掉的正是照片和店名那一头）。

     所以最后这一步不猜、只量：先把位移归零测出真实位置，越界多少就推回多少。
     推回之后它可能盖住自己那颗点位 —— 那是对的，每个地图 app 都这样，
     被裁掉半张卡才是错的。 */
  function clamp(root) {
    var map = root.querySelector('[data-map]');
    var pin = root.querySelector('[data-pin][aria-current="true"]');
    var pop = pin && pin.querySelector('.eb-map__pop');
    if (!map || !pop) return;

    pop.style.setProperty('--pop-dx', '0px');
    pop.style.setProperty('--pop-dy', '0px');
    var m = map.getBoundingClientRect();
    var p = pop.getBoundingClientRect();
    if (!p.height) return;

    var pad = 8, dx = 0, dy = 0;
    if (p.top < m.top + pad) dy = (m.top + pad) - p.top;
    else if (p.bottom > m.bottom - pad) dy = (m.bottom - pad) - p.bottom;
    if (p.left < m.left + pad) dx = (m.left + pad) - p.left;
    else if (p.right > m.right - pad) dx = (m.right - pad) - p.right;

    pop.style.setProperty('--pop-dx', Math.round(dx) + 'px');
    pop.style.setProperty('--pop-dy', Math.round(dy) + 'px');
  }

  /* 没有地图接管时（示意图形态）也要翻边：这时点位的百分比就是它的位置。 */
  function reflip(root) {
    var box = root.querySelector('[data-map]');
    if (!box) return;
    var w = box.offsetWidth, h = box.offsetHeight;
    if (!w || !h) return;
    [].forEach.call(root.querySelectorAll('[data-pin]'), function (pin) {
      var x = parseFloat(pin.style.getPropertyValue('--x'));
      var y = parseFloat(pin.style.getPropertyValue('--y'));
      if (isNaN(x) || isNaN(y)) return;
      flip(pin, (x / 100) * w, (y / 100) * h, w, h);
    });
    clamp(root);
  }

  function setTrigger(row, trigger) {
    var panel = row.closest('.eb-map__pickpanel');
    if (panel) {
      [].forEach.call(panel.querySelectorAll('[aria-current]'), function (r) {
        r.setAttribute('aria-current', r === row ? 'true' : 'false');
      });
    }
    if (trigger) trigger.textContent = row.dataset.label || row.textContent.trim();
    var details = row.closest('details');
    if (details) details.open = false;
  }

  function resetTriggers(root) {
    [].forEach.call(root.querySelectorAll('.eb-map__pickpanel'), function (panel) {
      var first = panel.querySelector('[aria-current]');
      [].forEach.call(panel.querySelectorAll('[aria-current]'), function (r) {
        r.setAttribute('aria-current', r === first ? 'true' : 'false');
      });
      if (first) {
        var trig = panel.closest('details').querySelector('[data-trig-model], [data-trig-country]');
        if (trig) trig.textContent = first.dataset.label || first.textContent.trim();
      }
    });
  }

  /* 定位。**失败要说人话** —— 浏览器拒绝的时候只静默是最气人的。 */
  function locate(root, state, apply) {
    var btn = root.querySelector('[data-map-geo]');
    var note = root.querySelector('[data-map-geonote]');
    if (!navigator.geolocation) { if (note) { note.hidden = false; } return; }
    if (btn) btn.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      state.here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      if (btn) btn.disabled = false;
      if (note) note.hidden = true;
      apply();
    }, function () {
      if (btn) btn.disabled = false;
      if (note) note.hidden = false;
    }, { timeout: 8000, maximumAge: 600000 });
  }

  /* ══ 真地图 ══════════════════════════════════════════════════
     三件事，顺序不能反：滚进视口才注入 → 注入完才建图 → 建完才摆点位。 */

  /* Leaflet 的两个文件只注入一次，多节共用同一个 promise。 */
  var leaflet = null;
  function load(css, js) {
    if (leaflet) return leaflet;
    leaflet = new Promise(function (done, fail) {
      if (window.L) { done(window.L); return; }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      document.head.appendChild(link);
      var tag = document.createElement('script');
      tag.src = js;
      tag.onload = function () { done(window.L); };
      tag.onerror = fail;
      document.head.appendChild(tag);
    });
    return leaflet;
  }

  function tiles(root, ready) {
    var el = root.querySelector('[data-map]');
    if (!el || !el.dataset.tiles || !el.dataset.leafletJs) return;

    /* **滚到了才请求。** 试骑页上地图在第一屏，所以多数人确实会看到它，
       但从下面的 FAQ 直接跳链进来的人不该为一张他没看的图付 160 KB。 */
    function go() {
      load(el.dataset.leafletCss, el.dataset.leafletJs).then(function (L) {
        if (!L) return;
        build(root, el, L, ready);
      })['catch'](function () {
        /* 注入失败＝没网或被拦。**什么都不做就是对的** ——
           底下那张示意图和它上面的点位一直都在，页面照常可用。 */
      });
    }

    if (!('IntersectionObserver' in window)) { go(); return; }
    var watch = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      watch.disconnect();
      go();
    }, { rootMargin: '200px' });
    watch.observe(el);
  }

  function build(root, el, L, ready) {
    var canvas = document.createElement('div');
    canvas.className = 'eb-map__canvas';
    /* 底纹和点位之间插进去：点位必须留在最上层 */
    el.insertBefore(canvas, el.querySelector('.eb-map__pin') || null);

    var map = L.map(canvas, {
      zoomAnimation: false,
      scrollWheelZoom: false,
      attributionControl: true,
      zoomControl: true,
      worldCopyJump: true
    });
    map.setView([50.5, 8], 4);

    L.tileLayer(el.dataset.tiles, {
      maxZoom: +el.dataset.tilesMax || 17,
      attribution: el.dataset.tilesAttr || '',
      crossOrigin: true,
      /* **高清屏上的「模糊」就是这里。** OSM 那类瓦片是 256 px 的，
         在 2x 屏上被浏览器整张放大一倍，路名和路网全糊。
         detectRetina 改成请求 zoom+1 的瓦片、再按一半尺寸画 —— 任何瓦片源
         都适用，不用把 URL 换成 @2x 版本（多数免费源也没有 @2x）。
         代价：瓦片请求数 ×4。真要上量应该换带 key 的瓦片服务，
         那类服务自己就发 @2x，届时把这行去掉即可。 */
      detectRetina: true
    }).addTo(map);

    /* Leaflet 自己那行「Leaflet | …」前缀去掉：版权该留的是**瓦片的**，
       库的名字不是版权，它只是页脚上一块别人的品牌。 */
    if (map.attributionControl) map.attributionControl.setPrefix('');

    /* **一下轻触把地图的控制权交出去，之前不交。**
       桌面上是滚轮：路过的人滚页面，想看的人点一下再缩放。
       手机上是拖拽：地图占掉小半屏，一进来就能拖的话，从它上面向下滑
       只会把地图拖走、页面纹丝不动 —— 人以为页面卡死了。点一下再拖。
       两处是同一条规矩的两种手势，所以写在一起。 */
    if (PHONE.matches) map.dragging.disable();
    function grab() {
      map.scrollWheelZoom.enable();
      map.dragging.enable();
    }
    map.once('focus', grab);
    canvas.addEventListener('click', grab);

    el.classList.add('is-streets');
    var note = root.querySelector('[data-map-note]');
    if (note) note.hidden = true;

    map.on('move zoom resize', function () { place(root, map); });
    /* 瓦片到齐之前容器尺寸可能还在变（图片、字体都会推） */
    setTimeout(function () { map.invalidateSize(); place(root, map); }, 60);

    if (ready) ready(map);
  }

  /* 点位重摆。**百分比不是像素** —— CSS 那条 `calc(var(--x) * 1%)` 是
     示意图和真地图共用的，两套摆法只有取值不同，样式一份。 */
  function place(root, map) {
    var box = map.getSize();
    if (!box.x || !box.y) return;
    [].forEach.call(root.querySelectorAll('[data-pin]'), function (pin) {
      if (!pin.dataset.lat) return;
      var p = map.latLngToContainerPoint([+pin.dataset.lat, +pin.dataset.lng]);
      pin.style.setProperty('--x', (p.x / box.x) * 100);
      pin.style.setProperty('--y', (p.y / box.y) * 100);
      flip(pin, p.x, p.y, box.x, box.y);
    });
    clamp(root);
  }

  /* 弹卡往哪边开。**这件事必须在运行时算，不能在服务端算。**
     服务端那套 `data-flip-*` 是按示意图那个固定投影算死的百分比 ——
     真地图一拖一缩点位就换了地方，那些属性立刻是错的，于是弹卡
     照旧往上开，被 `.eb-map` 的 overflow 从顶上切掉半张。

     阈值也不该是写死的 22%/78%：弹卡有照片时和没照片时高度差一倍。
     所以量它自己的 `offsetWidth/Height`（`visibility: hidden` 仍然有尺寸，
     `display: none` 才没有 —— 这也是当初用 visibility 关它的原因之一），
     再问「这一边装得下吗」。 */
  function flip(pin, x, y, w, h) {
    var pop = pin.querySelector('.eb-map__pop');
    if (!pop) return;
    var pw = pop.offsetWidth, ph = pop.offsetHeight;
    if (!pw || !ph) return;

    /* 竖向：默认往上开。上面装不下就翻下去 —— 除非下面更装不下，
       那就还是往上，至少主要内容贴着顶边而不是沉在框外。 */
    var upRoom = y - 14, downRoom = h - y - 14;
    var down = upRoom < ph && downRoom > upRoom;
    pin.toggleAttribute('data-flip-y', down);

    /* 横向：默认以点位为中心。哪边溢出就把那一边对齐到点位上。 */
    var half = pw / 2;
    pin.toggleAttribute('data-flip-x', x + half > w);
    pin.toggleAttribute('data-flip-xs', x - half < 0 && x + half <= w);
  }

  /* 取景：只看**此刻还显示着**的那些点。筛到一家就凑到那一家（但不要
     凑到街道级 —— 一张只有一颗点的街道图看不出它在哪个国家）。 */
  function fit(root, map) {
    var pts = [];
    [].forEach.call(root.querySelectorAll('[data-pin]'), function (pin) {
      if (pin.hidden || !pin.dataset.lat) return;
      pts.push([+pin.dataset.lat, +pin.dataset.lng]);
    });
    if (!pts.length) return;
    if (pts.length === 1) {
      /* 只剩一家时 9 是省级视野 —— 图上一个点浮在一片田里，
         「这家在哪」等于没回答。13 是城区级：认得出街区，也还看得见城市轮廓。 */
      map.setView(pts[0], Math.min(13, map.getMaxZoom()), { animate: true });
    } else {
      /* maxZoom 只在几家店挨得近时才生效（筛到一个城市）；
         店分散在几个国家时是 bounds 说了算，这个封顶碰不到。 */
      map.fitBounds(pts, { padding: [32, 32], maxZoom: 13, animate: true });
    }
    place(root, map);
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-store-map]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
